<script lang="ts">
    import type {ValueFormatResponse} from 'src/features/record/field-types/types';
    import {exists} from 'shared/utils/custom-utils';
    import {NUMBER_VIEW_FORMAT_RESPONSE} from 'src/features/record/field-types/types';
    import KpProgressBar from 'shared/ui-widgets/progress-bar/KpProgressBar.svelte';

    export let value: number;
    export let valueFormat: ValueFormatResponse | null = null;
    export let scale = 0;

    $: isPercentage = exists(valueFormat) && valueFormat.type === 'number_value_format' && valueFormat.viewFormat === NUMBER_VIEW_FORMAT_RESPONSE.PERCENTAGE;

    function formatNumber(num: number, scl: number): {
        whole: string;
        decimal: string | null,
        decimalSeparator: string | null
    } {
        const formatted = num.toLocaleString('cs', {
            minimumFractionDigits: scl,
            maximumFractionDigits: scl
        });

        if (scl === 0) {
            return {whole: formatted, decimal: null, decimalSeparator: null};
        }

        // Detect the decimal separator used in this locale
        const decimalSeparator = (1.1).toLocaleString('cs').substring(1, 2);
        const [whole, decimal = '00'] = formatted.split(decimalSeparator);

        return {whole, decimal, decimalSeparator};
    }
</script>

{#if isPercentage}
    <KpProgressBar percentageValue={value}/>
{:else}
    {@const numberParts = formatNumber(value, scale)}

    <span class="number-value">
        <span class="whole-part">{numberParts.whole}</span>

        {#if exists(numberParts.decimal) && exists(numberParts.decimalSeparator)}
            <span class="decimal-part">{numberParts.decimalSeparator}{numberParts.decimal}</span>
        {/if}
    </span>
{/if}

<style lang="less">
    @import (reference) "styles/portaro.variables.less";
    @import (reference) "styles/portaro.themes.less";

    .number-value {
        .whole-part {
            font-size: @font-size-default;
            font-weight: 500;
        }

        .decimal-part {
            color: @themed-text-muted;
        }
    }
</style>
